import React from 'react';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetTextArea from './../../widget/WidgetTextArea';

class AIChatInput extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),
        }
    }

    componentDidMount() {
        Widget.loadClass();
    }

    onChange = ( e ) => {

        if( this.props.notify )
        {
            this.props.notify(e, "onChange");
        }

        this.setState({value:e.target.value});
    }

    onKeyUp = ( e ) => {

        if( e.keyCode===13 && this.props.notify )
        {
            this.props.notify(e, "onKeyUp");
            this.setState({value:""});
        }
    }

    onClick = ( e ) => {

        if( this.props.notify )
        {
            this.props.notify(e, "onClick");
        }
    }

    send = () => {

        if( this.props.notify )
        {
            this.props.notify(null, "send");
        }

        this.setState({value:""});
    }

    link = () => {

        if( this.props.notify )
        {
            this.props.notify(null, "link");
        }
    }

    render()
    {
        const { sourcePath, value} = this.state;

        return (
            <div className="sf-ai-chat-input-border" component-data="ai-chat-input">
                <div className="sf-ai-chat-input-content">
                    <WidgetTextArea
                        value={value}
                        defaultValue={value}
                        style={{
                            height: "100px",
                            width: "100%",
                            border: "none",
                            padding: "12px 18px"
                        }}
                        placeholder="给我发消息"
                        onChange={this.onChange} 
                        onKeyUp={this.onKeyUp} 
                        onClick={this.onClick}
                    ></WidgetTextArea>
                </div>
                <div className="sf-ai-chat-input-footer">
                    <div className="sf-ai-chat-input-icon">
                        <div className="sf-ai-chat-input-icon-item">
                            <img src={require("./../../img/" + sourcePath +"/ai-chat/link.png")} onClick={this.link}/>
                        </div>
                        <div className="sf-ai-chat-input-icon-item">
                            <img src={require("./../../img/" + sourcePath +"/ai-chat/send.png")} onClick={this.send}/>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
}

export default AIChatInput;